// Removes ... and more and adds a +

document.addEventListener('DOMContentLoaded', () => {
  // Only run if a product form is on the page
  const root = document.querySelector('form[action*="/cart/add"], [data-product-form]');
  if (!root) return;

  const re = /(\d+(?:\.\d+)?)\s*kg\s*or\s*more/gi;
  const skip = /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|SELECT|OPTION|INPUT|TEXTAREA)$/;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach((textNode) => {
    const p = textNode.parentNode;
    if (!p || skip.test(p.nodeName) || !re.test(textNode.nodeValue)) return;

    const src = textNode.nodeValue;
    const frag = document.createDocumentFragment();
    let last = 0;

    src.replace(re, (match, num, idx) => {
      if (idx > last) frag.appendChild(document.createTextNode(src.slice(last, idx)));

      // Show "30kg+" but keep " or more" hidden in DOM
      frag.appendChild(document.createTextNode(num + 'kg'));
      const hidden = document.createElement('span');
      hidden.className = 'u-vh';
      hidden.textContent = ' or more';
      frag.appendChild(hidden);

      const plus = document.createElement('span');
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      frag.appendChild(plus);

      last = idx + match.length;
    });

    if (last < src.length) frag.appendChild(document.createTextNode(src.slice(last)));
    p.replaceChild(frag, textNode);
  });
});
